import { Expose } from 'class-transformer'

export class LogUserType {
  @Expose() avatarImgPath: string

  @Expose() displayName: string
}
